var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bid common-bg padding-nav " },
    [
      _c(
        "el-row",
        { staticClass: "bid-body" },
        [
          _c("topTime", { on: { refreshTime: _vm.refreshTime } }),
          _vm._v(" "),
          _c("bidNow", {
            ref: "bidNow",
            on: {
              setShowDetail: _vm.setShowDetail,
              refresh: _vm.refresh,
              refreshChart: _vm.refreshChart,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDetail
        ? _c("detail-comp", {
            ref: "bidDetail",
            staticStyle: { "margin-top": "1.6rem" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }